
    import { redirectLogin } from '@/helpers/redirectKeyclock';
    import {Action} from 'vuex-class';
    import {Component, Prop, Vue} from 'vue-property-decorator';
    import {email, helpers, maxLength, required} from 'vuelidate/lib/validators';
    import {AddEmployeeToCompanyModel} from '@/models/admin';

    import AccessPassPopup from '@/components/Service/Access/AccessPassPopup.vue';
    import {mdiAlert} from '@mdi/js';

    const namespace = 'commerce';

    const checkAlpha = () =>
        helpers.withParams(
            {type: 'checkAlpha'},
            (value) => {
                return !helpers.req(value) || !value.match(/[0-9]/);
            },
        );

    const checkConfirmation = () =>
        helpers.withParams(
            {type: 'checkConfirmation'},
            (value) => {
                return !helpers.req(value) || value;
            },
        );


    export interface TypeModel {
        text: string;
        value: string;
    }

    @Component({
        components: {
            AccessPassPopup,
        },
        data() {
            return {
                mdiAlert,
            };
        },
        validations: {
            email: {
                required,
                email,
            },
            firstName: {
                required,
                checkAlpha: checkAlpha(),
                maxLength: maxLength(50),
            },
            lastName: {
                required,
                checkAlpha: checkAlpha(),
                maxLength: maxLength(50),
            },
            patronymic: {
                checkAlpha: checkAlpha(),
                maxLength: maxLength(50),
            },
            confirmation: {
                checkConfirmation: checkConfirmation(),
            },
        },
    })
    export default class AccessPass extends Vue {
        @Prop() public companyId!: string;
        @Action('addEmployeeToCompany', {namespace}) public addEmployeeToCompany: any;

        private isAccessPassPopup: boolean = false;
        private errorMessage: string | null = null;

        private email: string = '';
        private lastName: string = '';
        private firstName: string = '';
        private patronymic: string = '';

        private confirmation: boolean = false;

        private requiredErrors(vPath: any, fildName: string) {
            const errors: string[] = [];

            if (vPath.$error && vPath.$params.checkAlpha && !vPath.checkAlpha) {
                errors.push('Поле заполнено некорректно. Запрещен ввод цифр.');
            }

            if (vPath.$error && vPath.$params.maxLength) {
                errors.push(`Максимальная длина поля ${vPath.$params.maxLength.max} символов`);
            }
            if (vPath.$error && !vPath.required && vPath.$params.required) {
                errors.push('Поле обязательно для заполнения');
            }
            if (vPath.$error && vPath.email === false) {
                errors.push(`Некорректный формат`);
            }
            return errors;
        }

        private onSave() {
            const data: AddEmployeeToCompanyModel = {
                lastname: this.lastName,
                firstname: this.firstName,
                patronymic: this.patronymic,
                email: this.email,
                companyId: this.companyId,
            };
            this.addEmployeeToCompany(data)
                .then((res: any) => {
                    this.isAccessPassPopup = false;
                    this.$store.dispatch('auth/logout');
                    redirectLogin();
                }).catch((err: any) => {
                if (err && err.data && err.data.error) {
                    this.errorMessage = err.data.error;
                    this.isAccessPassPopup = false;
                    this.$vuetify.goTo('#alert-scroll');
                }
            });
        }
    }
